import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-checkbox",
  "use": "icon-checkbox-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-checkbox\"><defs><style type=\"text/css\"></style></defs><path d=\"M921.6 0 102.4 0C46.08 0 0 46.08 0 102.4l0 819.2c0 56.32 46.08 102.4 102.4 102.4l819.2 0c56.32 0 102.4-46.08 102.4-102.4L1024 102.4C1024 46.08 977.92 0 921.6 0zM972.8 921.6c0 28.2368-22.9632 51.2-51.2 51.2L102.4 972.8c-28.2368 0-51.2-22.9632-51.2-51.2L51.2 102.4c0-28.2368 22.9632-51.2 51.2-51.2l819.2 0c28.2368 0 51.2 22.9632 51.2 51.2L972.8 921.6z\" p-id=\"10484\" /><path d=\"M854.7456 281.3952c-10.3936-7.3984-24.9216-5.0944-33.9584 3.9296L420.8768 685.248 203.5584 467.9296c-9.2416-9.2416-24.2176-11.776-34.7136-4.0064-12.8256 9.4976-13.8112 27.8912-2.9568 38.7456l236.8768 236.8768c9.9584 9.9584 26.2528 9.9584 36.1984 0l419.1232-419.1232C869.0688 309.4656 867.9552 290.8032 854.7456 281.3952z\" p-id=\"10485\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/checkbox.svg
// module id = LHos
// module chunks = 31